import { states } from '../utils/coding-details';

export default function States() {
    return states.map((state, index) => {
        if (index === 0) {
            return <option value="" key="initial"></option>;
        }
        return (
            <option value={state} key={state}>
                {state}
            </option>
        );
    });
}
